<template>
  <div>
    <CCard class="bg-style2">

      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6">
           <MultiLanguage :items="caption"  :disable="false"/>
<!--          <CIcon v-if="icon" :name="icon"/> {{ caption.filter(obj => { return (obj.key == lang) })[0].value }} -->
        </span>
      </CCardHeader>
      <CCardBody>

        <div v-for="(objs,parent) in item" :key="objs">

          <CRow @click="toggleDetails(objs, parent)">
            <CCol>
              <MultiLanguage caption="Title" :items="objs.title"  :disable="false"/>
              <MLEditor caption="Description" :items="objs.description"  :disable="false"/>
            </CCol>
          </CRow>
          <CDropdownDivider/>
          <CCollapse :show="Boolean(objs._toggled)" :duration="collapseDuration">
            <CRow v-for="(objsLevel, index) in objs.levels" :key="index">
              <CCol>
                <CCard class="bg-style2 mb-3">

                  <CCardHeader class="bg-secondary text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">

                    <CRow @click="toggleDetails(objsLevel, index)">
                      <CCol>
                        <MultiLanguage :items="objsLevel.title"  :disable="false" />
                      </CCol>
                    </CRow>
<!--                    <CButton size="sm" color="success" shape="pill" variant="outline" @click="onAddlevelChoine(parent,-1)">-->
<!--                      <span class="font-weight-bold"><CIcon name="cil-plus" /> </span>-->
<!--                    </CButton>-->
<!--                    <span class="font-weight-bold h6"> <CIcon name="cil-layers"/>  {{objsLevel.title.filter(obj => { return (obj.key == lang) })[0].value }} </span>-->
<!--                    <span class="font-weight-bold float-right"> {{ objsLevel.item.reduce(function (sum, objs) { return (objs.checked == true)? sum =sum+1:sum =sum;  }, 0) }}/{{objsLevel.item.length}}</span>-->
                  </CCardHeader>
                  <CCardBody class="p-3" >
                    <CCollapse :show="Boolean(objsLevel._toggled)" :duration="collapseDuration">
                      <CCol col="12">
                        <CRow  v-for="obj in objsLevel.item" :key="objs">
                          <CCol>
                            <MultiLanguage :items="obj.title" />
                          </CCol>
                        </CRow>
                        <CRow>
                          <CCol class="text-right">
                            <CButton size="sm" color="success" shape="pill" variant="outline" @click="onAddlevelChoine(parent,index)">
                              <span class="font-weight-bold"><CIcon name="cil-plus" /> </span>
                            </CButton>
                          </CCol>
                        </CRow>
                      </CCol>
                    </CCollapse>
                  </CCardBody>

                </CCard>
              </CCol>

            </CRow>

          </CCollapse>

          <CRow>
            <CCol class="text-right" v-if="parent == item.length-1">
              <CButton size="sm" color="success" shape="pill" variant="outline" @click="onAddlevelChoine(parent,-1)">
                <span class="font-weight-bold"><CIcon name="cil-plus" /> </span>
              </CButton>
            </CCol>
          </CRow>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import MultiLanguage from "@/projects/components/Util/MultiLanguage";
import MLEditor from "@/projects/components/Util/MLEditor";

export default {
  name: 'ECometencys',
  components: {MLEditor, MultiLanguage},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },

    caption: {
      type: String,
      default: 'Banks'
    },
    level: {
      type: Number,
      default: 1
    },


    item: {
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,

    subFields : {
      type: Array,
      default() {
        return [
          {key: "no", label: "#", _style: 'width:50px; text-align: center'},
          {key: "code", label: "Core"},
          {key: "in", label: "Check In"},
          {key: "out", label: "Check Out"},
        ]
      }
    }

  },

  data: function () {
    return {
      collapseDuration: 0,
      collapse:true

    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {
    },

    onAddlevelChoine(parent,index){

      var defualt = [
        {
          "value": "",
          "key": "en"
        },
        {
          "value": "",
          "key": "th"
        }
      ]

      var objs = {}
      objs.description = [
        {
          "value": "",
          "key": "en"
        },
        {
          "value": "",
          "key": "th"
        }
      ];
      objs.title = [
        {
          "value": "",
          "key": "en"
        },
        {
          "value": "",
          "key": "th"
        }
      ];

      if(index == -1){
        objs.levels = []


        for(var i=0; i<5; i++){
          var objsL = {}
          objsL.description = [
            {
              "value": "",
              "key": "en"
            },
            {
              "value": "",
              "key": "th"
            }
          ];
          objsL.title = [
            {
              "value": "",
              "key": "en"
            },
            {
              "value": "",
              "key": "th"
            }
          ];
          objsL.item = [];
          objs.levels.push(objsL);
        }

        this.$props.item.push(objs)

      }else{
        this.$props.item[parent].levels[index].item.push(objs)
      }



    },

    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    }



  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
